"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur 已并入SAP',
    learn: {
      href: '',
      text: '了解更多'
    }
  },
  social: [{
    network: 'linkedin',
    href: ''
  }, {
    network: 'wechat',
    href: '/wechat-qr'
  }],
  support: {
    links: [{
      text: '加入我们',
      href: '/careers'
    }, {
      text: '联系我们',
      href: '/contact'
    }, {
      text: '销售热线：400-675-6753'
    }],
    selector: '国家和地区选择',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: '隐私政策',
      href: ''
    }, {
      text: '使用条款',
      href: ''
    }, {
      text: '沪ICP备09046015号-25'
    }]
  }
};